export const SerialEnforcementLevel = {
  Block: 'Block',
  Warn: 'Warn',
  Allow: 'Allow',
} as const;

export type SerialEnforcementLevel = (typeof SerialEnforcementLevel)[keyof typeof SerialEnforcementLevel];
